import { render, staticRenderFns } from "./RegisterPrivateProcess.vue?vue&type=template&id=c98de0b8&scoped=true&"
import script from "./RegisterPrivateProcess.vue?vue&type=script&lang=js&"
export * from "./RegisterPrivateProcess.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPrivateProcess.vue?vue&type=style&index=0&id=c98de0b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98de0b8",
  null
  
)

export default component.exports